import { useContext } from "react";
import { OrganizationsContext } from "./OrganizationsContext";

export const useOrganizations = () => {
    return useContext(OrganizationsContext);
};
